Service = App.loadClass 'core::Angular/Service'

class exports.SmsResubscribeService extends Service
    constructor: (@http, @rootScope) ->
        undefined

    getUnsubscribedSmses: () =>
        @http.post 'backend/admin/new-tools/sms-resubscribe/get-unsubscribed-smses'

    resubscribeSms: (smsId) =>
        @http.post 'backend/admin/new-tools/sms-resubscribe/resubscribe',
            smsId: smsId
